import { render, staticRenderFns } from "./AlertGrid.vue?vue&type=template&id=5f8ca4ce"
import script from "./AlertGrid.vue?vue&type=script&lang=js"
export * from "./AlertGrid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports